import React from 'react';
import { GeneratePaymentRequestWizardPageProps } from 'src/containers/self-service/generate-payment-request/components/GeneratePaymentRequestWizard';
import { CategoryType } from 'src/containers/self-service/generate-payment-request/components/PreferredPaymentRequest';
import {
  PageName,
  PaymentRequestTealiumService,
} from 'src/containers/self-service/generate-payment-request/tagging/payment-request-tealium-service';
import { NotificationMethod, PaymentType } from 'src/services/payment-request-service';

enum NotificationMethodDescription {
  Email = 'Email Address',
  SMS = 'Mobile number',
}

export const getSummaryPageName = (
  paymentType: PaymentType,
  notificationType: NotificationMethod,
): PageName => {
  if (paymentType === PaymentType.FixedAmount) {
    return notificationType === NotificationMethod.Email
      ? PageName.GENERATE_PAYMENT_REQUEST_SUMMARY_FIXED_EMAIL
      : PageName.GENERATE_PAYMENT_REQUEST_SUMMARY_FIXED_SMS;
  }

  return notificationType === NotificationMethod.Email
    ? PageName.GENERATE_PAYMENT_REQUEST_SUMMARY_VARIABLE_EMAIL
    : PageName.GENERATE_PAYMENT_REQUEST_SUMMARY_VARIABLE_SMS;
};

export function Summary({
  formValues,
  submitForm,
  setOnNextEventHandler,
  setOnBackEventHandler,
}: GeneratePaymentRequestWizardPageProps) {
  React.useEffect(() => {
    setOnBackEventHandler(() => {
      PaymentRequestTealiumService.onBackButton(
        getSummaryPageName(formValues.categoryType, formValues.notificationMethod),
      );
    });
    setOnNextEventHandler(() => {
      submitForm();

      formValues.categoryType === PaymentType.FixedAmount &&
        PaymentRequestTealiumService.onSendRequestFixedPayment(formValues.notificationMethod);
      formValues.categoryType === PaymentType.VariableAmount &&
        PaymentRequestTealiumService.onSendRequestVariablePayment(formValues.notificationMethod);
    });

    formValues.categoryType === PaymentType.FixedAmount &&
      PaymentRequestTealiumService.onSummaryFixedStart(formValues.notificationMethod);
    formValues.categoryType === PaymentType.VariableAmount &&
      PaymentRequestTealiumService.onSummaryVariableStart(formValues.notificationMethod);
  }, []);

  return (
    <section className="flex flex-col items-center justify-center gap-10">
      <div className="text-center text-white">
        <p className="mb-4 text-3xl font-medium">Payment Request Summary</p>
        <p>Please confirm the details below are correct.</p>
      </div>
      <div className="grid gap-8 bg-grey-800 md:min-w-130 rounded-32 p-9">
        <h3 className="text-3xl font-medium">
          Your {CategoryType[formValues.categoryType]} information
        </h3>

        {formValues.categoryType === PaymentType.FixedAmount && (
          <div className="grid grid-cols-2">
            <p className="text-lg font-medium">Transaction Reference</p>
            <p className="text-lg font-medium">Amount</p>
            <p className="text-lg font-normal text-grey-300">{formValues.transactionReference}</p>
            <p className="text-lg font-normal text-grey-300">
              {`R ${formValues.transactionAmount}`}
            </p>
          </div>
        )}

        <div className="grid grid-cols-2">
          <p className="text-lg font-medium">Notification Type</p>
          <p className="text-lg font-medium capitalize">
            {NotificationMethodDescription[formValues.notificationMethod]}
          </p>
          <p className="text-lg font-normal text-grey-300">{formValues.notificationMethod}</p>
          <p className="text-lg font-normal break-words text-grey-300">
            {formValues.notificationAddress}
          </p>
        </div>
      </div>
    </section>
  );
}
